import { render } from "./LectureNotes.vue?vue&type=template&id=365baa0e&scoped=true"
import script from "./LectureNotes.vue?vue&type=script&lang=js"
export * from "./LectureNotes.vue?vue&type=script&lang=js"

import "./LectureNotes.vue?vue&type=style&index=0&id=365baa0e&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365baa0e"]])

export default __exports__